import mixpanel from 'mixpanel-browser';
import {
  createContext,
  MutableRefObject,
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { authContext } from "./Authentication/authContext";
import {env} from '../config'

console.log(env)

const token = 'eb482944ac80c7877836da540558d0f6';

export const TrackingEvents:any = {
    'userLoggedIn': 'userLoggedIn',
  'state-selected': 'state-selected',
  'selectedtypeChange':'selectedtypeChange',
  'default':'default',
  'cityChange':'cityChange',
  'zipCodeChange':'zipCodeChange',
  'tabChange':'tabChange',
  'intervalChange':'intervalChange',
  'adjustedPredictionChange':'adjustedPredictionChange',
  'demographicValueChange':'demographicValueChange'
};

export interface AnalyticsContextObject {
  track: (eventName: string, body?: any) => void;
  timeEvent: (eventName: string) => void;
  loaded: boolean;
  loadedRef: MutableRefObject<boolean>;
}

export const AnalyticsContext = createContext<AnalyticsContextObject>(
  {} as AnalyticsContextObject,
);

export function useAnalytics(): AnalyticsContextObject {
  return useContext(AnalyticsContext);
}

interface AnalyticsProviderProps {
  children: ReactNode | ReactNode[];
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const loadedRef = useRef<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const { dispatch, state }: any = useContext(authContext);

//   const projectId = useProjectId();

console.log(state,env)


  useEffect(() => {
    mixpanel.init(token);
    loadedRef.current = true;
    setLoaded(true);

    // timeEvent(TrackingEvents['closed-cdp']);
    // track(TrackingEvents['open-cdp']);
    // track(TrackingEvents['environment-loaded'], {
    //   environment: process.env['VITE_APP_ENVIRONMENT'],
    // });
    // window.addEventListener('beforeunload', onUnload);

    // return () => {
    //   onUnload();
    //   window.removeEventListener('beforeunload', onUnload);
    // };
  }, []);

  useEffect(() => {
    if (Object.keys(state.user).length != 0) {
        console.log('dfghj')
      setUserProfileInMixpanel(state.user);
    }
  }, [state.user]);

//   useEffect(() => {
//     if (Boolean(projectId)) {
//       track('Project-Loaded', { projectId: projectId });
//     }
//   }, [projectId]);

  function onUnload() {
    track('closed-cdp');
  }

  function maskEmail(email: string): string {
    const [username, domain] = email.split('@');

    const maskPart = (part: string) => {
      if (part.length <= 4) {
        return `${part[0]}${'*'.repeat(part.length - 2)}${part[part.length - 1]}`;
      }
      return `${part.slice(0, 2)}${'*'.repeat(part.length - 4)}${part.slice(-2)}`;
    };

    const maskedUsername = maskPart(username);
    const maskedDomain = maskPart(domain);

    return `${maskedUsername}@${maskedDomain}`;
  }

  function setUserProfileInMixpanel(userDetail: any) {
    const { firstname, lastname, email, jobTitle } = userDetail;
    const maskedEmail = maskEmail(email);
    mixpanel.identify(maskedEmail);
    mixpanel.people.set({
      $name:firstname+" "+lastname,
      $first_name: firstname,
      $last_name: lastname,
      $email: maskedEmail,
      jobTitle: jobTitle,
      env: env
    });
  }

  function timeEvent(eventName: string) {
    mixpanel.time_event(eventName);
  }

  function track(eventName: string, body?: any) {
    const bodyWithEnvironment = {
      ...body,
      env: env,
    };

    if (loadedRef.current) {
      mixpanel.track(eventName, bodyWithEnvironment);
    }
  }

  const analyticsContextObject: AnalyticsContextObject = {
    track,
    timeEvent,
    loaded,
    loadedRef,
  };

  return (
    <AnalyticsContext.Provider value={analyticsContextObject}>
      {children}
    </AnalyticsContext.Provider>
  );
}